import React from "react";
import { observer } from "mobx-react";
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';

import SurveySection from './SurveySection';
import SurveyConditionalSegment from './SurveyConditionalSegment';

import ibsStore from './Stores/IbsSurveyStore'
import sharedStore from "./Stores/SharedStore";
import generalStore from "./Stores/SurveyStore"

import { changeSurveyCtrl } from "../control"
import { SurveyTypeURL, CURRENT_DATA_YEAR, HISTORICAL_BASE_YEAR } from '../Enums/constants';
import { createDbProduct, createDcProduct, checkIfAnalyst } from "../Services/IBS/IbsService";
import { isAPRA, isLGPS } from "../ibsHelper";


const historicalAccessYears = CURRENT_DATA_YEAR - 8;

const getSurveyStatusText = ({ SurveyStatusID, NumChanges }) => {
	if (!SurveyStatusID || SurveyStatusID === 0) {
		return NumChanges === 0 ? " (Not Started)" : ` (${NumChanges} changes)`;
	}
	return " (Submitted)";
};

const checkDcPlanExists = (planID) =>
	generalStore.availablePlanProducts.some(p => p.PlanId === planID && p.ProductID === 2);

const handleYearChange = async (surveyId, planId, productType) => {
	ibsStore.mandateData = [];
	await changeSurveyCtrl(surveyId, planId, productType);
};

const createNewSurvey = (type, planId) => {
	if (type === "DB") return createDbProduct(planId);
	if (type === "DC") return createDcProduct(planId);
};

const getAdjustedYear = (survey) =>
	(survey?.ReturnMonth === 3 || survey?.ReturnMonth === 6) ? 1 : 0;

const renderCurrentSurveyCardIBS = (productType, planID, planName) => {
	let currentSurveyLink = "No survey selected";

	const currentSurvey = generalStore.allAvailableSurveys.filter(survey =>
		survey.DataYear === sharedStore.currentDataYear &&
		survey.ProductID === productType &&
		survey.PlanID === planID)[0];

	if (typeof currentSurvey !== 'undefined' && currentSurvey.SurveyID != null) {
		const productTypeName = productType === 1 ? "DB" : "DC"
		currentSurveyLink = (
			<NavLink tag={Link} to={currentSurvey.isAgreed || currentSurvey.DataYear < CURRENT_DATA_YEAR ? "PlanInfo" : "TermsAndConditions"}>
				<span className="surveyQuickStartLink card2" onClick={() => handleYearChange(currentSurvey.SurveyID, planID, productTypeName)}>
					<h6>{currentSurvey.PlanSponsor}</h6>
					<h8>{(productType === 1) ? (checkDcPlanExists(planID) ? "Defined Benefit Survey " : "Investment Benchmarking Survey") : "Defined Contribution Survey"}</h8><br />
					<h8>{(currentSurvey.DataYear + getAdjustedYear(currentSurvey))}</h8>
					<h9 style={{ color: '#5c8cce', display: 'block', textAlign: 'right' }}>{getSurveyStatusText(currentSurvey)}</h9>
				</span>&nbsp;&nbsp;
			</NavLink>
		)
	} else {
		const newProductTypeName = productType === 1 ? "DB" : "DC";
		if (newProductTypeName.length > 0) {
			// This is a way to adjust the year shown depending on the return month. \
			// If there is a better way to check Return month here, switch to that instead.
			let surveyYearAdjustment = isLGPS() || isAPRA() ? 1 : 0;
			currentSurveyLink = (
				<NavLink tag={Link}>
					<span className="surveyQuickStartLink card2" onClick={() => createNewSurvey(newProductTypeName, planID)}>
						<h6>{planName}</h6>
						<h8>{(productType === 1) ? (checkDcPlanExists(planID) ? "Defined Benefit Survey " : "Investment Benchmarking Survey") : "Defined Contribution Survey"}</h8><br />
						<h8>{sharedStore.currentDataYear + surveyYearAdjustment}</h8>
						<h9 style={{ color: '#5c8cce', display: 'block', textAlign: 'right' }}>Get Started</h9>
					</span>&nbsp;&nbsp;
				</NavLink>
			);
		}
	}
	return currentSurveyLink;
}

const renderHistoricalSurveyCardsIBS = (productType, planID) => {
	//filter for survey with avilablable survey datayear 2019
	var productTypeName = productType == 1 ? "DB" : "DC"
	var recentSurveyHistorical;
	var historicalSurveys;

	if (generalStore.allAvailableSurveys) {
		recentSurveyHistorical = generalStore.allAvailableSurveys.filter(survey =>
			survey.DataYear !== sharedStore.currentDataYear &&
			survey.SurveyID !== null &&
			survey.PlanID === planID &&
			survey.ProductID === productType
		);

		historicalSurveys = recentSurveyHistorical.map((survey) => {
			return (
				<NavLink tag={Link} to={"PlanInfo"}><span className="surveyQuickStartLink card2" onClick={() => handleYearChange(survey.SurveyID, planID, productTypeName)}>
					<h6>{survey?.PlanSponsor}</h6>
					<h8>{(productType === 1) ? (checkDcPlanExists(planID) ? "Defined Benefit Survey " : "Investment Benchmarking Survey") : "Defined Contribution Survey"}</h8><br />
					<h8>{(survey.DataYear + getAdjustedYear(survey))}</h8>
				</span></NavLink>
			)
		})
	}
	return historicalSurveys;
}

const renderFooterIBS = () => {
  let allCurrentSurveys = generalStore.availablePlanProducts.map(function (item, i) {
        return renderCurrentSurveyCardIBS(item.ProductID, parseInt(item.PlanId, 10), item.PlanSponsor)
    })

    let allHistoricalSurveys = generalStore.availablePlanProducts.map(function (item, i) {
        return renderHistoricalSurveyCardsIBS(item.ProductID, parseInt(item.PlanId, 10))
    })

	return (
		<React.Fragment>
			<SurveyConditionalSegment>
				<SurveySection labelText="Current year surveys">
					<span className="subAccountPanelStyle">
						{allCurrentSurveys}
					</span>

				</SurveySection>
				<SurveySection labelText="Historical surveys">
					{(allHistoricalSurveys !== "None" && allHistoricalSurveys) &&
						<span className="subAccountPanelStyle">
							{allHistoricalSurveys}
						</span>
					}
				</SurveySection>
			</SurveyConditionalSegment>
		</React.Fragment>
	);
}

const renderCurrentSurveyCardPABS = (survey) => {

	let currentSurveyLink = "No survey selected";

	// Ripped from NavMenu.js, need to refactor code for getting orgname
	// Why isn't it in the struct?
	let organizationName = "";
	const result = generalStore.availablePlanProducts.filter(word => word.PlanId === generalStore.currentSurvey?.SystemId);
	organizationName = result[0]?.OrgName

	if (survey) {
		currentSurveyLink = (
			<NavLink tag={Link} to={generalStore.nextPagePath}>
				<span className="surveyQuickStartLink card2" onClick={() => handleYearChange(survey.SurveyId, survey.SystemId, "PABS")}>
					<h6>{organizationName}</h6>
					<h8>{survey.SurveyTypeId === 5 ? "PABS UK" : "PABS"}</h8><br />
					<h8>{survey.DataYear}</h8>
					<h9 style={{ color: '#5c8cce', display: 'block', textAlign: 'right' }}>{getSurveyStatusText(survey)}</h9>
				</span>&nbsp;&nbsp;
			</NavLink>
		)
	} else {
		currentSurveyLink = "Start " + sharedStore.currentDataYear + " PABS survey";
		currentSurveyLink = (
			<NavLink tag={Link} to={generalStore.nextPagePath} >
				<span className="surveyQuickStartLink card2" onClick={() => createNewSurvey("PABS", survey.SystemId)}>
					<h6>{survey.OrgName}</h6>
					<h8>{survey.SurveyTypeId === 5 ? "PABS UK" : "PABS"}</h8><br />
					<h8>{sharedStore.currentDataYear}</h8>
					<h9 style={{ color: '#5c8cce', display: 'block', textAlign: 'right' }}>Get Started</h9>
				</span>&nbsp;&nbsp;
			</NavLink>
		);
	}
	return currentSurveyLink;
}

const renderHistoricalSurveyCardsPABS = (surveyList) => {

	// Ripped from NavMenu.js, need to refactor code for getting orgname
	// Why isn't it in the struct?
	let organizationName = "";
	const result = generalStore.availablePlanProducts.filter(word => word.PlanId === generalStore.currentSurvey?.SystemId);
	organizationName = result[0]?.OrgName

	return surveyList.map((s) => (
		<NavLink tag={Link} to={generalStore.nextPagePath}>
			<span className="surveyQuickStartLink card2" onClick={() => handleYearChange(s.SurveyId, s.SystemId, "PABS")}>
				<h6>{organizationName}</h6>
				<h8>{s.SurveyTypeId === 5 ? "PABS UK" : "PABS"}</h8><br />
				<h8>{s.DataYear}</h8>
			</span>
		</NavLink>
	));
};

const renderFooterPABS = () => {
	const currentSurveys = generalStore.availableSurveys
		.filter(s =>
			s.DataYear === sharedStore.currentDataYear &&
			s.SystemId === generalStore.currentSurvey.SystemId &&
			s.SurveyTypeId === generalStore.currentSurvey.SurveyTypeId
		)
		.map(s => renderCurrentSurveyCardPABS(s));

	const historicalSurveyList = generalStore.availableSurveys
		.filter(s =>
			s.DataYear < sharedStore.currentDataYear &&
			s.DataYear >= historicalAccessYears &&
			s.SystemId === generalStore.currentSurvey.SystemId &&
			s.SurveyTypeId === generalStore.currentSurvey.SurveyTypeId
		)
		.sort((a, b) => b.DataYear - a.DataYear);

	const historicalSurveys = renderHistoricalSurveyCardsPABS(historicalSurveyList);

	const hasCurrent = currentSurveys.length > 0;
	const hasHistorical = Array.isArray(historicalSurveys) && historicalSurveys.length > 0;
	return (
		<>
			{hasCurrent && (
				<SurveyConditionalSegment>
					<SurveySection labelText="Current year surveys">
						<span className="subAccountPanelStyle">
							{currentSurveys}
						</span>
					</SurveySection>
				</SurveyConditionalSegment>
			)}

			{hasHistorical && (
				<SurveyConditionalSegment>
					<SurveySection labelText="Historical surveys">
						<span className="subAccountPanelStyle">
							{historicalSurveys}
						</span>
					</SurveySection>
				</SurveyConditionalSegment>
			)}
		</>
	);
};


const GenericHomeDetails = observer((props) => {

	//Client view
	if (!ibsStore.accountInfo || ibsStore.accountInfo.UserRoleID !== 3 || !checkIfAnalyst()) {
		if (generalStore.surveyTypeUrl === SurveyTypeURL.DB || generalStore.surveyTypeUrl === SurveyTypeURL.DC) {
			return renderFooterIBS();
		} else if (generalStore.surveyTypeUrl === SurveyTypeURL.PABS || generalStore.surveyTypeUrl === SurveyTypeURL.PABS_UK || generalStore.surveyTypeUrl === SurveyTypeURL.PABS_LG) {
			return renderFooterPABS();
		}

	}

	//Analyst view
	else {
		let extraLine;
		if (!window.location.href.includes("/ibs/home"))
			return (
				<React.Fragment>
					{extraLine}
					<Link to={`laundromat`}>
						<button type="button" style={{ marginLeft: '1px' }} className="btn btn-add-row">Open Laundromat</button>
					</Link>
					{renderFooterIBS()}
				</React.Fragment>
			);
	}

})

export default GenericHomeDetails;
